import "./CppTuts.css";

// create a react component for the CppTuts route
export default function CppTuts(props: any) {
  return (
    <>
      <div className="navBar">
          <div className="navBarBrand">
            <a href="/">Home</a>
          </div>
      </div>
      <div>
        <h1>C++ Tutorials</h1>
        <p>
          This is ideally where tutorial stuff would go, I guess. Coming soon.
        </p>
      </div>
    </>
  );
}
